import { CloudProviders } from '@ariksa/cloud-account/api';
import { NativeResources } from '@ariksa/inventory-core/api';

export const DynamicSummaryResourceTypes = [
  NativeResources.Aks,
  NativeResources.AWSSageMakerEndpoint,
];

export const isGoogleWorkspaceProvider = (provider?: string) =>
  provider?.toLowerCase().replace('_', '') ===
  CloudProviders.GoogleWorkspace.replace('_', '');

// Providers whose Summary tab is built from the inventory metadata API
// (ui_metadata in cloud-resources) instead of a hand-written component.
const DynamicSummaryProviders: string[] = [
  CloudProviders.Gcp,
  CloudProviders.Azure,
  CloudProviders.Gitlab,
  CloudProviders.Github,
];

export const usesDynamicSummary = (
  resourceType?: string,
  provider?: string,
) => {
  const type = resourceType?.toLowerCase();
  return (
    !!type?.match(/^(gcp|azure|googleworkspace|gitlab|github)/) ||
    DynamicSummaryProviders.includes(provider?.toLowerCase() ?? '') ||
    isGoogleWorkspaceProvider(provider) ||
    (!!resourceType &&
      DynamicSummaryResourceTypes.includes(resourceType as NativeResources))
  );
};
